<template>
  <div class="flow-create-form-wrap">
    <el-tabs v-model="form_type" type="border-card">
      <el-tab-pane label="PC" name="PC">
        <v-form-designer :banned-widgets="testBanned"
                         :designer-config="designerConfig"
                         :field-list-api="fieldList"
                         :host_url="host_url"
                         v-if="stepIndex === 3"
                         ref="formDesignerPC"></v-form-designer>
      </el-tab-pane>
       <el-tab-pane label="H5" name="H5">
        <MVFormDesigner :banned-widgets="testBanned"
                         :designer-config="designerConfig"
                         :field-list-api="fieldList"
                         :host_url="host_url"
                         v-if="stepIndex === 3"
                         ref="formDesignerH5"></MVFormDesigner>
      </el-tab-pane>
    </el-tabs>


    <select-personnel ref="selectPersonnel" />
    <HouseReductionSelect ref="HouseReductionSelect" />
    <ErpRoomUser ref="ErpRoomUser" />
    <SelectProjectHouse ref="SelectProjectHouse" />
    <select-department ref="selectDepartment" />
    <SelectExpenseAccount ref="SelectExpenseAccount" />
    <InfoExpenseAccount ref="InfoExpenseAccount" />
    <SelectBudgetItemsByMonth ref="SelectBudgetItemsByMonth" />
    <SelectFlow ref="SelectFlow" />
    <SelectBank ref="SelectBank" />
    <SelectUsePeriod ref="SelectUsePeriod" />
    <SelectJKD ref="SelectJKD" />
    <UploadFile ref="UploadFile" />
    <SelectSupplier ref="SelectSupplier" />
    <SelectWorkClass ref="SelectWorkClass" />
    <SelectMaterial ref="SelectMaterial" />
    <SelectYearCode ref="SelectYearCode" />

  </div>
</template>

<script>

import Http from "../common/Http";
import flowFromMixins from "../flowFromMixins";
import InfoExpenseAccount from "./InfoExpenseAccount";

export default {
  name:"flow-create-form",
  components: {InfoExpenseAccount},
  props: ["value"],
  data () {
    return {
      form: {},
      form_h5:{},
      testBanned: [
        'sub-form',
        'alert',
      ],
      designerConfig: {
        languageMenu: true,
        widgetNameReadonly:false,
        generateSFCButton:false,
      },
      fieldList: [],
      fieldJson: this.value.model.field_json,
      host_url:Http.getBaseURL(),
      stepIndex:this.$parent.stepIndex,
      form_type:"PC"
    }
  },
  mixins:[flowFromMixins],
  provide() {
    return {
      __FLOW_PAGE__:this
    }
  },
  created() {
    // this.fieldList = [
    //   {
    //     fieldName: 'accountName',
    //     fieldLabel: '客户名称'
    //   },
    //
    //   {
    //     fieldName: 'mobilePhone',
    //     fieldLabel: '手机号码'
    //   },
    // ]
    this.fieldJsonTofieldList()
  },
  watch: {
    fieldJson:{
      deep:true,
      immediate:true,
      handler(n){
        this.fieldJsonTofieldList()
      }
    }
  },
  activated() {
    console.log('flow form activated')

    if(this.value.master.cache) {
      this.form = this.value.master.cache.form
    } else if (this.value.form) {
      this.form = this.value.form
    } else {
      this.form = {vform_json: '',h5_vform_json: ''}
      this.value.form = this.form
    }

    // 更新vform数据
    let model_table = '', sheet_id = '';
    if(this.value.master.cache) {

      if(this.value.master.cache.model) {
        model_table = this.value.master.cache.model.model_table
      }

      if(this.value.master.cache.sheet) {
        sheet_id = this.value.master.cache.sheet.id
      }

    } else {

      if(this.value.model) model_table = this.value.model.model_table
      if(this.value.sheet) sheet_id = parseInt(this.value.sheet.id)

    }

    let formJson = this.form.vform_json ? JSON.parse(this.form.vform_json) : {
      "widgetList": [],
      "formConfig": {
        "modelName": "",
        "refName": "vForm",
        "rulesName": "rules",
        "flowName": "",
        "labelWidth": 80,
        "labelPosition": "left",
        "size": "",
        "labelAlign": "label-left-align",
        "cssCode": "",
        "customClass": "",
        "functions": "",
        "layoutType": "PC",
        "onFormCreated": "",
        "onFormMounted": "",
        "onFormDataChange": ""
      }
    }

    let formJson_H5 = this.form.h5_vform_json ? JSON.parse(this.form.h5_vform_json) : {
      "widgetList": [],
      "formConfig": {
        "modelName": "",
        "refName": "vForm",
        "rulesName": "rules",
        "flowName": "",
        "labelWidth": 80,
        "labelPosition": "left",
        "size": "",
        "labelAlign": "label-left-align",
        "cssCode": "",
        "customClass": "",
        "functions": "",
        "layoutType": "H5",
        "onFormCreated": "",
        "onFormMounted": "",
        "onFormDataChange": ""
      }
    }

    formJson.formConfig.modelName = model_table
    formJson.formConfig.flowName = sheet_id
    formJson.formConfig.layoutType = "PC"

    formJson_H5.formConfig.modelName = model_table
    formJson_H5.formConfig.flowName = sheet_id
    formJson_H5.formConfig.layoutType = "H5"

    if (this.stepIndex === 3) {
      console.log(formJson,formJson_H5)
      this.$refs['formDesignerPC'].setFormJson(formJson)
      this.$refs['formDesignerH5'].setFormJson(formJson_H5)
    }


  },
  methods: {
    saveFormJson() {
      let formJson = this.$refs['formDesignerPC'].getFormJson()
      let formJson_H5 = this.$refs['formDesignerH5'].getFormJson()
      this.form.vform_json = JSON.stringify(formJson)
      this.form.h5_vform_json = JSON.stringify(formJson_H5)
    },
    setFormJson(data) {
      this.$refs['formDesigner'+this.form_type].setFormJson(data)
    },
    fieldJsonTofieldList() {
      let fieldJson = [];
      if (typeof this.value.model.field_json != 'undefined' && this.value.model.field_json !== '') {
        fieldJson = this.value.model.field_json
      }
      if (typeof this.$parent.flowData.model.field_json != 'undefined' && this.$parent.flowData.model.field_json !== '') {
        fieldJson = this.$parent.flowData.model.field_json
      }

      // let fieldJson = this.value.model.field_json
      this.fieldList = [];
      fieldJson.forEach(fieldItem => {
        this.fieldList.push({
          fieldLabel: fieldItem['field_description'],
          fieldName: fieldItem['field_name']
        })
      })
      //判断是否有子表，若有也加入进去
      if (typeof this.value.model.model_child_json !== 'undefined' && this.value.model.model_child_json.length > 0) {
        let modelChildJson = this.value.model.model_child_json
        for (let i=0; i < modelChildJson.length; i++) {
          modelChildJson[i].field_json.forEach(fieldItem => {
            this.fieldList.push({
              fieldLabel: fieldItem['field_description']+'('+modelChildJson[i].model_table+')',
              fieldName: fieldItem['field_name']
            })
          })
        }
      }
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>

@import '../common.scss';

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowCreateForm.vue